import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../services/auth/AuthContext';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { Container } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import userService from '../../../../services/api/profile';
import Navbar from '../../../../components/shared-menu/Navbar';
import SideBar from '../../../../components/shared-menu/Sidebar';

import PersonalDetails from './personalInfo';
import KYCBankDetailsPage from './kycAndBank';
import OverlayLoader from '../../../../components/overlayLoader';
import PotentialEarnings from './PotentialEarnings';

export default function MyProfileDashboard(props) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state
  const { setIsAuthenticated, user: authUser } = useAuth();
  const userRoles = authUser.role;
  const navigate = useNavigate();

  const pages = [
    {
      label: "user_profile.personal_details.header",
      value: "personal_details",
      allowedRoles: ["reseller", "partner", "connector", "rm"],
    },
    {
      label: "user_profile.kyc_and_bank.header",
      value: "kyc_and_bank",
      allowedRoles: ["reseller", "connector", "rm"],
    },
    {
      label: 'dashboard.pages.my_earnings',
      value: 'my_earnings',
      allowedRoles: ["reseller", "connector", "rm"],
    },
  ];

  // The sidebar is role-filtered, so a partner sees a single entry. A nav rail
  // for one destination is noise: only show it once there is a choice.
  const visiblePages = pages.filter(({ allowedRoles }) =>
    allowedRoles?.includes('*') || allowedRoles?.some((role) => userRoles.includes(role))
  );
  const showSidebar = visiblePages.length > 1;

  const [searchParams, setSearchParams] = useSearchParams({ page: pages[0].value });
  const currentPage = searchParams.get('page') ?? pages[0].value;
  const setCurrentPage = (page) => setSearchParams((searchParams) => {
    searchParams.set('page', page.value);
    return searchParams;
  });

  const renderPage = (page) => {
    switch (page) {
      case 'personal_details':
        return user && <PersonalDetails user={user} />;
      case 'kyc_and_bank':
        return user && <KYCBankDetailsPage user={user} />;
      case 'my_earnings':
        const ALLOWED_ROLES = ['borrower', 'connector', 'rm'];
        if (ALLOWED_ROLES.some(role => userRoles.includes(role))) {
          return user && <PotentialEarnings user={user} />;
        }
        return <Typography>Page not found</Typography>;
      default:
        return <Typography>Page not found</Typography>;
    }
  };

  useEffect(() => {
    setLoading(true);
    userService.getUserProfile(setIsAuthenticated, navigate, true)
      .then((response) => {
        setUser(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setIsAuthenticated, navigate]);

  return (
      <Box display="flex" flexDirection="column" minHeight="100vh">

        <OverlayLoader
          open={loading}
          text="Loading user profile..."
        />

        <Navbar />

        <Box display="flex" flexWrap="wrap" flexGrow={1}>
          {showSidebar && (
            <Box
              sx={({ palette, breakpoints }) => ({
                [breakpoints.down('lg')]: {
                  p: 1,
                  width: '100%',
                  backgroundColor: palette.background.paper,
                },
              })}
            >
              <SideBar
                pages={pages}
                selectedPage={currentPage}
                setSelection={setCurrentPage}
              />
            </Box>
          )}

          <Box
            flexGrow={1}
            sx={(theme) => ({
              ...(showSidebar && { borderLeft: `1px solid ${theme.palette.divider}` }),
            })}
          >
            <Container sx={{ py: 4 }}>
              {renderPage(currentPage)}
            </Container>
          </Box>
        </Box>

      </Box>
    );
}